import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http.service';
import { privateApiUrl } from '../../../private/private-apiUrl';
import sessionStorageUtility from '../../../common/utils/sessionStorage';
import { CommonViewResponse } from '../../../common/response/response';
import { LIVE_DATA_PARAMETER_RESPONSE } from '../../../private/live-data/live-data/live-data';

@Injectable()
export class IotIntelligenceCardService {
    constructor(private httpService: HttpService) {}

    getDeviceParameters(deviceId: string, range: string = 'live'): Promise<CommonViewResponse<LIVE_DATA_PARAMETER_RESPONSE[]>> {
        const { tenant_parent_flag, user_id, user_super_admin_flag } = sessionStorageUtility.getLoginUserDetails();
        const payload = {
            tenant_id: 'SENSESIANT',
            tenant_parent_flag,
            user_id,
            user_super_admin_flag,
            device_id: deviceId,
            range,
            offset: 0,
            limit: 5000,
        };
        return this.httpService.postAuth<CommonViewResponse<LIVE_DATA_PARAMETER_RESPONSE[]>>(
            `${privateApiUrl.DEVICE_INTELLIGENCE}`,
            payload,
            true
        );
    }
}
